import React from "react";
import DownloadUsersPage from "./DownloadUserPage";

const module = {
  routeProps: {
    path: "DownloadUsers",
    component: DownloadUsersPage,
  },

  name: "Download User Accounts",
  label: " Download User Accounts",
  title: "Download User Accounts",
  showOnMenu: true,
};

export default module;
